import OpenStreetMapBaseComponent from '@layouts/default/components/open-street-map-base/open-street-map-base.component'
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import * as Leaflet from 'leaflet';
import { Config } from '@shared/config';

@Component({
    selector: 'app-open-street-map-with-marker',
    templateUrl: './open-street-map-with-marker.component.html',
    styleUrls: [
        '../open-street-map-base/open-street-map-base.component.scss',
        './open-street-map-with-marker.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export default class OpenStreetMapWithMarkerComponent extends OpenStreetMapBaseComponent implements OnInit {
    @Input() form: UntypedFormGroup = null
    @Input() formControlPrefix: string = ''
    @Input() updatePositionOnMapClick: boolean = true
    @Input() markerDraggable: boolean = true
    @Input() enableScrollWheelZoom: boolean = true

    public internalForm: UntypedFormGroup = new UntypedFormGroup({
        latitude: new UntypedFormControl(),
        longitude: new UntypedFormControl()
    })

    public controlNames: { latitude: string, longitude: string }
    public marker: Leaflet.Marker = null

    mapOptions(): Leaflet.MapOptions {
        return {
            layers: Config.OPEN_STREET_MAP_LAYERS,
            zoom: 10,
            center: {
                lat: this.currentPosition()[0],
                lng: this.currentPosition()[1]
            } as Leaflet.LatLngLiteral,
            gestureHandling: this.enableScrollWheelZoom,
            scrollWheelZoom: this.enableScrollWheelZoom
        } as Leaflet.MapOptions
    }

    ngOnInit() {
        this.controlNames = this.formControlNames()

        if (this.form != null) {
            this.form.addControl('latitude', this.internalForm.get('latitude'))
            this.form.addControl('longitude', this.internalForm.get('longitude'))
        }
    }

    currentPosition(): [number, number] {
        return [+this.internalForm.value.latitude, +this.internalForm.value.longitude]
    }

    afterMapLoad() {
        this.marker = Leaflet.marker(this.currentPosition(), {
            icon: Leaflet.divIcon({
                className: 'osm-map-marker standard-marker',
                iconSize: [this.MARKER_ICON_WIDTH, this.MARKER_ICON_HEIGHT],
                iconAnchor: [this.MARKER_ICON_WIDTH / 2, this.MARKER_ICON_HEIGHT]
            }),
            draggable: this.markerDraggable
        }).addTo(this.map)

        const that = this
        if (this.updatePositionOnMapClick) {
            this.map.on('click', (e: Leaflet.LeafletMouseEvent) => {
                that.updatePosition(e.latlng.lat, e.latlng.lng)
            })
        }

        if (this.markerDraggable) {
            this.marker.on('dragend', (e: Leaflet.LeafletMouseEvent) => {
                that.updatePosition(e.latlng.lat, e.latlng.lng)
            })
        }
    }

    formControlNames(): { latitude: string, longitude: string } {
        if (this.formControlPrefix == '') {
            return {
                latitude: 'latitude',
                longitude: 'longitude'
            }
        } else {
            return {
                latitude: this.formControlPrefix + '.latitude',
                longitude: this.formControlPrefix + '.longitude'
            }
        }
    }

    updatePosition(lat: number, lng: number) {
        this.internalForm.patchValue({
            latitude: lat,
            longitude: lng
        })

        this.form?.get(this.controlNames.latitude)?.setValue(lat.toString())
        this.form?.get(this.controlNames.longitude)?.setValue(lng.toString())

        console.log(this.form?.value)

        this.marker?.setLatLng({ lat: lat, lng: lng })
        this.map?.panTo({ lat: lat, lng: lng })
    }
}
